import { render } from "./Top10.vue?vue&type=template&id=03a747ce"
import script from "./Top10.vue?vue&type=script&lang=js"
export * from "./Top10.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/kingdoms/Top10.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03a747ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03a747ce', __exports__)) {
    api.reload('03a747ce', __exports__)
  }
  
  module.hot.accept("./Top10.vue?vue&type=template&id=03a747ce", () => {
    api.rerender('03a747ce', render)
  })

}


export default __exports__